var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FlyToObject } from 'src/app/engine/state/engine.actions';
import { Store, Select } from '@ngxs/store';
import { SetObjectLayerOrder } from 'src/app/engine/state/engine.actions';
import { EditState } from 'src/app/edit/state/edit.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { CollapseNode, ExpandNode, CheckNode, ToggleVisibleNodes, SetCheckedNodes, } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { TreeTheme } from '../tree/tree.component';
import { environment } from 'src/environments/environment';
import { GraphUtils } from 'src/lib/graph/graph-utils';
export class TreeNestedNodeComponent {
    constructor(store, graphService, changeDetection) {
        this.store = store;
        this.graphService = graphService;
        this.changeDetection = changeDetection;
        this.treeTheme = TreeTheme;
        this.isLoft = environment.exportType === 'module';
        this.nested = true;
        this.theme = TreeTheme.Dark;
        this.checked = false;
        this.hasChildren = false;
        // DOM friendly version of node ID
        // nodeID may include pipe characters, which cause errors with querySelector
        this.sanitizedID = '';
        this.ngUnsubscribe = new Subject();
    }
    get node() {
        return this._node;
    }
    set node(value) {
        this._node = value;
        this.sanitizedID = this.graphService.sanitizeNodeID(this.node.id);
        this.checked = this.isChecked(this.node);
        this.hasChildren = GraphUtils.getSuccessors(this.graph, this.node.id).length > 0;
        this.changeDetection.markForCheck();
    }
    ngOnInit() {
        this.checkedNodesIds$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(nodeIds => {
            this.checked = nodeIds.some((id) => id === this.node.id);
            this.changeDetection.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    handleExpandClick(node, expanded) {
        (expanded) ?
            this.store.dispatch(new CollapseNode(node)) :
            this.store.dispatch(new ExpandNode(node));
    }
    handleNodeClick(event, node) {
        if (event.shiftKey) {
            this.checkNode(node);
        }
        else {
            this.setCheckedNodes(node);
            this.store.dispatch(new FlyToObject(node.id));
            this.handleExpandClick(node, false);
        }
    }
    toggleVisible(node, show) {
        show = (typeof show === 'undefined') ? !node.boolState.shown : show;
        this.store.dispatch(new ToggleVisibleNodes([node], show));
        this.changeDetection.markForCheck();
    }
    handleLayerOrder(event, node) {
        if ((event instanceof KeyboardEvent && event.key.toLowerCase() === 'enter') ||
            event instanceof FocusEvent) {
            const eventTarget = event.target;
            const layer = parseInt(eventTarget.value, 10);
            this.setLayerOrder(node, layer);
        }
    }
    isChecked(node) {
        return this.store.selectSnapshot(EngineNodesState.getCheckedNodes)
            .some(checkedNode => checkedNode.id === node.id);
    }
    checkNode(node, checked) {
        if (typeof checked === 'undefined') {
            // When not explicitly defiend, toggle the node checked state
            checked = !this.isChecked(node);
        }
        this.store.dispatch(new CheckNode(node, checked));
    }
    setCheckedNodes(node, checked) {
        if (typeof checked === 'undefined') {
            // When not explicitly defiend, toggle the node checked state
            checked = !this.isChecked(node);
        }
        const nodes = checked ? [node] : [];
        this.store.dispatch(new SetCheckedNodes(nodes));
    }
    setLayerOrder(node, layer) {
        this.store.dispatch(new SetObjectLayerOrder([node], layer));
        this.changeDetection.markForCheck();
    }
}
__decorate([
    Select(EngineNodesState.getCheckedNodeIds),
    __metadata("design:type", Observable)
], TreeNestedNodeComponent.prototype, "checkedNodesIds$", void 0);
__decorate([
    Select(EditState.getLayerOrderMode),
    __metadata("design:type", Observable)
], TreeNestedNodeComponent.prototype, "layerOrderMode$", void 0);
